<div class="row" style="margin: 0px; background-color: white;">
    <div class="col-md-12 col-12 col-sm-12" style="padding: 15px 15px 10px 15px; display: inline-block; border-bottom: 1px solid #dee2e6;">
        <div class="col-md-6 col-6 col-sm-6 lblHeader newHeader" style="display: inline-block; padding: 0px;">
            <span id="ApntmntHdr" style="vertical-align: super; font-size: 18px;">Add Ledger</span>
        </div>    
        <div class="col-md-6 col-6 col-sm-6" style="display: inline-block; padding: 0px;">
            <span class="btn btn-darkGreen brdrRadius3" style="padding: 3px 9px 3px; line-height: 1.66em; font-size: 13px; float: right;" (click)="saveLedger()">
                <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>  
    </div>
    
    <div class="col-md-12 col-12 col-sm-12" style="padding: 15px;">
    <div class="col-md-12 col-sm-12 col-12" style="font-size: 13px; padding: 0px;">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
            <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                Parent Group :
            </div>
            <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75 font12 formCtlFltr" [(ngModel)]="newLedger.accountHead"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let sh of heads" [value]="sh.HeadID">{{sh.HeadName}}</option>
                </select>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
            <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                Ledger Name :
            </div>
            <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                <input type="text" class="form-control wid75 font12 formCtlFltr" [(ngModel)]="newLedger.ledgerName" id="txtNewLedger">
            </div>
        </div>

        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
            <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                <span style="vertical-align: -webkit-baseline-middle;">Link with :</span>
            </div>
            <div class="col-md-9 col-sm-9 col-9" style="display: inline-block; padding: 0px;">
                <div class="budge2 btn lableBtnOrange padLeft5 hvrInfo btnBottom brdrRadius3 {{ newLedger.type == 0 ? 'lableBtnOrange-active' : '' }}"
                style="font-size: 13px; margin: 0px; margin-right: 5px;" (click)="ledgerType(0)">None</div>

                <div class="budge2 btn lableBtnRed  padLeft5 hvrInfo btnBottom brdrRadius3 {{ newLedger.type == 1 ? 'lableBtnYellow-active' : '' }}"
                    style="font-size: 13px; margin: 0px; margin-right: 5px;" (click)="ledgerType(1)">Customer</div>


                <div class="budge2 btn lableBtGreenMain padLeft5 hvrInfo btnBottom brdrRadius3 {{ newLedger.type == 2 ? 'lableBtGreenMain-active' : '' }}"
                    style="font-size: 13px; margin: 0px; margin-right: 5px;" (click)="ledgerType(2)">Supplier</div>
                <div class="budge2 btn lableBtTill padLeft5 hvrInfo btnBottom brdrRadius3 {{ newLedger.type == 3 ? 'lableBtTill-active' : '' }}"
                    style="font-size: 13px; margin: 0px; margin-right: 5px;" (click)="ledgerType(3)">Bank</div>
                <div class="budge2 btn lableBtnDarkBlue padLeft5 hvrInfo btnBottom brdrRadius3 {{ newLedger.type == 4 ? 'lableBtnDarkBlue-active' : '' }}"
                    style="font-size: 13px; margin: 0px; margin-right: 5px;" (click)="ledgerType(4)">Cash</div>
                <div class="budge2 btn lableBtTill padLeft5 hvrInfo btnBottom brdrRadius3 {{ newLedger.type == 5 ? 'lableBtTill-active' : '' }}"
                    style="font-size: 13px; display: none; margin: 0px; margin-right: 5px;" (click)="ledgerType(5)">Employee</div>
            </div>
        </div>

        <!-- <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
            <div class="displayb col-md-3 col-sm-3 col-4" style="padding: 0px; line-height: 40px; color: #333333; display: inline-block;">Link with :
            </div>
            <div class="col-md-9 col-sm-9 col-9" style="display: inline-block; padding: 0px;">
                <div class="budge2 btn lableBtnOrange padLeft5 hvrInfo btnBottom {{ newLedger.type == 0 ? 'lableBtnOrange-active' : '' }}"
                style="font-size: 13px; margin-left: 0px;" (click)="ledgerType(0)">None</div>
            <div class="budge2 btn lableBtnYellow padLeft5 hvrInfo btnBottom {{ newLedger.type == 1 ? 'lableBtnYellow-active' : '' }}"
                style="font-size: 13px; margin-left: 0px;" (click)="ledgerType(1)">Customer</div>
            <div class="budge2 btn lableBtGreenMain padLeft5 hvrInfo btnBottom {{ newLedger.type == 2 ? 'lableBtGreenMain-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(2)">Supplier</div>
            <div class="budge2 btn lableBtTill padLeft5 hvrInfo btnBottom {{ newLedger.type == 3 ? 'lableBtTill-active' : '' }}"
                style="font-size: 13px;" (click)="ledgerType(3)">Bank</div>
            <div class="budge2 btn lableBtnDarkBlue padLeft5 hvrInfo btnBottom {{ newLedger.type == 4 ? 'lableBtnDarkBlue-active' : '' }}"
                style="font-size: 13px; display: none;" (click)="ledgerType(4)">Cash</div>
            <div class="budge2 btn lableBtTill padLeft5 hvrInfo btnBottom {{ newLedger.type == 5 ? 'lableBtTill-active' : '' }}"
                style="font-size: 13px; display: none;" (click)="ledgerType(5)">Employee</div>
            </div>
        </div> -->
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="newLedger.type == 1">
            <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">Customer :
            </div>
            <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75 font12 formCtlFltr" [(ngModel)]="newLedger.customerId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let c of customers | sort : 'Cmp' : 0" [value]="c.RI">
                        <!-- {{c.Cmp}} -->
                        {{c.Cmp == '-' ? c.Name : c.Cmp + ' / ' + c.Name}} 
                    </option>
                </select>
                <!-- <input class="form-control wid100" list="customers" [(ngModel)]="newLedger.customerName"
                    placeholder="Select Customer" (blur)="customerChange();">
                <datalist id="customers">
                    <option *ngFor="let c of customers | sort : 'CompanyName' : 0" [value]="c.CompanyName">
                        {{c.CompanyName}}
                    </option>
                </datalist> -->

                <div class="budge2 btn lableBtGreenMain padLeft5 hvrInfo btnBottom brdrRadius3"
                    style="font-size: 13px; margin: 0px; margin-left: 5px; position: absolute; font-size: 19px; padding: 0px 10px;" (click)="ledgerType(2)">+</div>

            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="newLedger.type == 2">
            <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">Supplier :
            </div>
            <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                <select class="form-control wid75 font12 formCtlFltr" [(ngModel)]="newLedger.supplierId"
                    style="padding-left: 0px !important; cursor: pointer;">
                    <option value="0">Select</option>
                    <option *ngFor="let s of suppliers | sort : 'Cmp' : 0" [value]="s.RI">
                        {{s.Cmp}}</option>
                </select>
                <!-- <input class="form-control wid100" list="supplierList" [(ngModel)]="newLedger.supplierName"
                    placeholder="Select Supplier" (blur)="supplierChange();">
                <datalist id="supplierList">
                    <option *ngFor="let c of suppliers | sort : 'CompanyName' : 0" [value]="c.CompanyName">
                        {{c.CompanyName}}
                    </option>
                </datalist> -->
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;" *ngIf="newLedger.type == 3">
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                    Bank Name :
                </div>
                <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12 formCtlFltr" [(ngModel)]="bank.name" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">Branch :</div>
                <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12 formCtlFltr" [(ngModel)]="bank.branch" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">IFSC :</div>
                <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12 formCtlFltr" [(ngModel)]="bank.ifsc" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;">
                <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                    Account No :
                </div>
                <div class="col-md-6 col-sm-6 col-6" style="display: inline-block; padding: 0px;">
                    <input type="text" class="form-control font12 formCtlFltr" [(ngModel)]="bank.accNo" />
                </div>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12 nozero"
            style="padding: 0px; margin-top: 15px; cursor: pointer; font-size: 13px; color: #1F628E;"
            *ngIf="!isShowZeroBal" (click)="isShowZeroBal = !isShowZeroBal">
            Set non-zero opening balance
        </div>
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px; margin-top: 15px;" *ngIf="isShowZeroBal">
            <div class="col-md-3 col-sm-3 col-4" style="padding: 0px; display: inline-block; color: #333333;">
                Opening (₹) :
            </div>
            <div class="col-md-3 col-sm-3 col-3" style="display: inline-block; padding-left: 0px;">
                <input type="text" class="form-control formCtlFltr" style="text-align: right; width: inherit;"
                    [(ngModel)]="newLedger.openingBal" (keyup)="onlyNumberAlllow()">
            </div>
            <div class="col-md-2 col-sm-2 col-3" style="display: inline-block;">
                <select class="form-control wid75 formCtlFltr" [(ngModel)]="newLedger.curr" style="padding-left: 0px !important; cursor: pointer;">
                    <option value="Db">Db</option>
                    <option value="Cr">Cr</option>
                </select>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-sm-12 col-12" style="margin-top: 15px; padding: 0px;">
        <span (click)="saveLedger()" class="btn btn-darkGreen brdrRadius3" style="padding: 3px 9px 3px; line-height: 1.66em; font-size: 13px;" >
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
    
    </div>
</div>

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>

